import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notice-press13',
  templateUrl: './notice-press13.component.html',
  styleUrls: ['./notice-press13.component.scss']
})
export class NoticePress13Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
